import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "../../config/authaxios";

import Chip from "@material-ui/core/Chip";
import { useLocation, useNavigate } from "react-router-dom";
import { FormControlLabel, Switch, TextField, Typography } from "@mui/material";
import CountrySelect from "../../ui/CountrySelect";
import { getCountryId } from "../../services/countries";

function Edit() {
  const search = useLocation().search;
  const navigate = useNavigate();
  const couponId = new URLSearchParams(search).get("couponId");

  const [coupons, setCoupons] = useState({});
  const [priceArray, setPriceArray] = useState([]);
  const [priceInput, setPriceInput] = useState(null);
  const [pointArray, setPointArray] = useState([]);
  const [pointInput, setPointInput] = useState(null);
  const [detailColorArray, setDetailColorArray] = useState(["#000", "#000", "#000"]);
  const [detailColorInput, setDetiailColorInput] = useState([]);
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [outerColor, setOuterColor] = useState(null);
  const [isCustomCurrency, setIsCustomCurrency] = useState(false);
  const [denominationsCustom, setDenominationsCustom] = useState([]);
  const [denominationsCustomInput, setDenominationsCustomInput] = useState("");

  const [image, setImage] = useState();
  const [smallImage, setSmallImage] = useState();
  const [desc1, setDesc1] = useState();
  const [desc2, setDesc2] = useState();
  const [desc3, setDesc3] = useState();
  const [countryId, setCountryId] = useState("");

  const sortedDenominationsCustom = [...denominationsCustom].sort(
    (a, b) => Number(a) - Number(b)
  );

  const fetchCouponDetail = () => {
    axios.get(`/admin/qwik-voucehr/detail/${couponId}`).then((res) => {
      let data = res.data.response;
      setImage(res?.data?.response?.images?.mobile);

      if (res.data.status) {
        const response = res.data.response;
        setCoupons(response);
        const denominations = response?.price?.denominations ?? [];
        setPriceArray([...denominations].sort((a, b) => Number(a) - Number(b)));
        setPointArray(response?.how_to_use_points ?? []);
        setDetailColorArray(
          !response?.detail_colors?.length
            ? ["#000", "#000", "#000"]
            : response.detail_colors
        );
        setSmallImage(response?.images?.small);
        setMin(response?.price?.min);
        setMax(response?.price?.max);
        setOuterColor(response?.outer_color);
        setDesc1(response?.description);
        setDesc2(response?.how_to_use_desc);
        setDesc3(response?.brand_desc);
        setCountryId(getCountryId(response?.country));
        setIsCustomCurrency(!!response?.price?.is_custom_currency);

        // Normalize denominations_custom to a plain array of values
        const rawCustom = response?.price?.denominations_custom;
        let normalizedCustom = [];
        if (Array.isArray(rawCustom)) {
          normalizedCustom = rawCustom.map((item) =>
            item && typeof item === "object" ? item.value : item
          );
        } else if (rawCustom && typeof rawCustom === "object") {
          normalizedCustom = Object.values(rawCustom);
        }
        normalizedCustom = normalizedCustom
          .filter((v) => v !== undefined && v !== null && v !== "")
          .sort((a, b) => Number(a) - Number(b));
        setDenominationsCustom(normalizedCustom);
      }
    });
  };

  useEffect(() => {
    setTimeout(() => {
      fetchCouponDetail();
    }, 500);
  }, []);

  const handlefileInput = (e) => {
    const Dataform = new FormData();
    Dataform.append("file", e.target.files[0]);
    let FileSize = Number(e.target.files[0].size / 1000);
    var file = e.target.files[0];
    var _URL = window.URL || window.webkitURL;
    let img = new Image();
    var width, height;
    img.onload = function () {
      width = this.width;
      height = this.height;
      axios.post(`/admin/upload-image`, Dataform).then((res) => {
        let data = res.data.Image.url;

        if (e.target.id == "image") {
          setImage(data);
        } else {
          setSmallImage(data);
        }
      });
      alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
    };
    img.onerror = function () {
      alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
  };

  const onChangeHandler = (e) => {
    setCoupons({ ...coupons, [e.target.id]: e.target.value });
  };

  const handlePriceInput = (e) => {
    const val = e.target.value;
    if (val === "" || /^\d*$/.test(val)) {
      setPriceInput([val]);
    }
  };

  const AddPriceInArray = () => {
    const val = Array.isArray(priceInput)
      ? String(priceInput[0]).trim()
      : String(priceInput ?? "").trim();
    if (val === "") return;
    if (Number(val) <= 0) {
      alert("Price value should be greater than 0");
      return;
    }
    if (Number(val) < Number(min) || Number(val) > Number(max)) {
      alert(`Value should be between ${min ?? "--"} to ${max ?? "--"}`);
      return;
    }
    if (priceArray.some((p) => Number(p) === Number(val))) {
      alert("This Price value is already added");
      return;
    }
    let temp = [...priceArray, val].sort((a, b) => Number(a) - Number(b));
    setPriceArray(temp);
    setPriceInput("");
  };

  const AddPointInArray = () => {
    let temp = pointArray;
    temp.push(pointInput);
    setPointArray(temp);
    setPointInput("");
  };

  const AddColorInArray = () => {
    let temp = detailColorArray;
    temp.push(...detailColorInput);
    setDetailColorArray(temp);
    setDetiailColorInput("");
  };

  const handleDenominationCustomInput = (e) => {
    const val = e.target.value;
    if (val === "" || /^\d*$/.test(val)) {
      setDenominationsCustomInput(val);
    }
  };

  const AddDenominationCustomInArray = () => {
    const val = String(denominationsCustomInput).trim();
    if (val === "") return;
    if (Number(val) <= 0) {
      alert("Custom Denomination value should be greater than 0");
      return;
    }
    if (Number(val) < Number(min) || Number(val) > Number(max)) {
      alert(`Value should be between ${min ?? "--"} to ${max ?? "--"}`);
      return;
    }
    if (denominationsCustom.some((d) => Number(d) === Number(val))) {
      alert("This Custom Denomination value is already added");
      return;
    }
    setDenominationsCustom((prev) =>
      [...prev, val].sort((a, b) => Number(a) - Number(b))
    );
    setDenominationsCustomInput("");
  };

  const handleDeleteDenominationCustom = (index) => {
    setDenominationsCustom((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDeleteRule = (index) => {
    let temp = priceArray;
    temp.splice(index, 1);
    setPriceArray([...temp]);
  };

  const handleDeletePoint = (index) => {
    let temp = pointArray;
    temp.splice(index, 1);
    setPointArray([...temp]);
  };

  const handleColorPoint = (index) => {
    let temp = detailColorArray;
    temp.splice(index, 1);
    setDetailColorArray([...temp]);
  };

  const updateHandler = () => {
    if (!isCustomCurrency && (!priceArray || priceArray.length === 0)) {
      alert("Please add at least one Price.");
      return;
    }

    if (
      isCustomCurrency &&
      (!denominationsCustom || denominationsCustom.length === 0)
    ) {
      alert(
        "Please add at least one Custom Denomination when Custom Currency is enabled."
      );
      return;
    }

    const priceInvalid = (priceArray || []).some((v) => Number(v) <= 0);
    if (!isCustomCurrency && priceInvalid) {
      alert("Price value should be greater than 0");
      return;
    }

    const hasInvalid = (denominationsCustom || []).some(
      (v) => Number(v) <= 0
    );
    if (isCustomCurrency && hasInvalid) {
      alert("Custom Denomination value should be greater than 0");
      return;
    }

    const priceSet = new Set((priceArray || []).map((v) => Number(v)));
    if (!isCustomCurrency && priceSet.size !== (priceArray || []).length) {
      alert("Duplicate Price values are not allowed");
      return;
    }

    const denomSet = new Set(
      (denominationsCustom || []).map((v) => Number(v))
    );
    if (
      isCustomCurrency &&
      denomSet.size !== (denominationsCustom || []).length
    ) {
      alert("Duplicate Custom Denomination values are not allowed");
      return;
    }

    let obj = { ...coupons };
    obj.voucherId = couponId;
    obj.name = coupons.name;
    obj.image = image;
    obj.description = desc1;
    obj.how_to_use_desc = desc2;
    obj.brand_desc = desc3;

    obj.price = priceArray;
    obj.how_to_use_points = pointArray;
    obj.expiry = coupons.expiry;
    obj.small = smallImage;
    obj.outer_color = outerColor;
    obj.detail_colors = detailColorArray;
    obj.c_percentage = coupons.c_percentage;
    obj.partner_link = coupons.partner_link;
    obj.country = countryId;
    obj.is_custom_currency = isCustomCurrency;
    obj.currencyName = "";
    obj.denominations_custom = isCustomCurrency
      ? [...denominationsCustom].sort((a, b) => Number(a) - Number(b))
      : [];

    axios.put(`/admin/qwik-voucehrs`, obj).then((res) => {
      alert(res.data.message);
      if (res.data.status) {
        navigate("/qscouponlist");
      }
    });
  };

  const colorHandler = (e) => {
    setOuterColor(e.target.value);
  };

  const closeHandler = () => {
    const colorPicker = document.getElementById("outercolor");
    colorPicker.addEventListener("input", () => {
      colorPicker.blur();
    });
  };

  const onChangeHandlerColor = (index, newColor) => {
    const updatedColors = [...detailColorArray];
    updatedColors[index] = newColor;
    setDetailColorArray(updatedColors);
  };

  return (
    <>
      <div
        style={{
          margin: "10px 0px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          background: "#fff",
          padding: "10px",
        }}
      >
        <section
          style={{
            display: "flex",
            alignItems: "space-between",
            justifyContent: "center",
            border: "2px solid gray",
            borderRadius: "12px",
            width: "100%",
            gap: "30px",
            padding: "10px",
            marginTop: "20px",
          }}
        >
          <section
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <section>
              <Typography> Name :</Typography>
              <TextField
                type="text"
                className="rounded  py-2"
                id="name"
                value={coupons.name}
                onChange={onChangeHandler}
              />
            </section>
            <section style={{ maxWidth: "600px" }}>
              <Typography>Description :</Typography>

              <ReactQuill
                theme="snow"
                value={desc1}
                onChange={(e) => {
                  setDesc1(e);
                }}
              />
            </section>

            <section style={{ maxWidth: "600px" }}>
              <Typography>How to use Description :</Typography>

              <ReactQuill
                theme="snow"
                value={desc2}
                onChange={(e) => {
                  setDesc2(e);
                }}
              />
            </section>

            <section style={{ maxWidth: "600px" }}>
              <Typography>Brand Description :</Typography>

              <ReactQuill
                theme="snow"
                value={desc3}
                onChange={(e) => {
                  setDesc3(e);
                }}
              />
            </section>

            <section>
              <Typography>Image :</Typography>
              {image ? (
                <button
                  onClick={() => {
                    setImage("");
                  }}
                >
                  Re-Upload
                </button>
              ) : (
                <TextField
                  type="file"
                  id="image"
                  onChange={handlefileInput}
                  placeholder="Select Image"
                  accept="image/*"
                />
              )}
            </section>
            <section>{image && <img src={image} width={"50px"} />}</section>

            <section>
              <Typography> Outer Color :</Typography>
              <TextField
                type="color"
                className="rounded  py-2"
                style={{ width: "100px" }}
                id="outercolor"
                value={outerColor}
                onChange={(e) => {
                  colorHandler(e);
                }}
                onClick={closeHandler}
              />
            </section>
          </section>
          <section
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <section>
              <Typography>Country :</Typography>
              <CountrySelect value={countryId} onChange={setCountryId} />
            </section>
            <section>
              <Typography> Expiry :</Typography>
              <TextField
                type="text"
                className="rounded  py-2"
                id="expiry"
                value={coupons.expiry}
                onChange={onChangeHandler}
              />
            </section>

            {/* PRICE — enabled only when custom currency is OFF */}
            <section>
              <Typography> Price :</Typography>
              <Typography style={{ color: "red", fontSize: "14px" }}>
                <strong>Note:</strong> Price range must be between {min ?? "--"}{" "}
                to {max ?? "--"}
              </Typography>
              <TextField
                type="text"
                className="rounded  py-2"
                id="price"
                value={
                  Array.isArray(priceInput)
                    ? priceInput[0] ?? ""
                    : priceInput ?? ""
                }
                disabled={isCustomCurrency}
                onChange={handlePriceInput}
              />
              <button
                disabled={
                  isCustomCurrency ||
                  !priceInput ||
                  (Array.isArray(priceInput) && !priceInput[0]) ||
                  Number(
                    Array.isArray(priceInput) ? priceInput[0] : priceInput
                  ) <= 0
                }
                onClick={AddPriceInArray}
              >
                {priceInput ? "Add Price" : "Enter Price"}
              </button>
            </section>
            <section>
              {priceArray.length > 0 &&
                priceArray.map((item, index) => {
                  return (
                    <Chip
                      key={index}
                      onDelete={
                        isCustomCurrency
                          ? undefined
                          : () => {
                            handleDeleteRule(index);
                          }
                      }
                      label={item}
                    />
                  );
                })}
            </section>

            <section>
              <FormControlLabel
                control={
                  <Switch
                    checked={isCustomCurrency}
                    onChange={(e) => setIsCustomCurrency(e.target.checked)}
                  />
                }
                label="Enable Custom Currency"
              />
            </section>

            {/* CUSTOM DENOMINATION — enabled only when custom currency is ON */}
            <section
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                border: "1px dashed gray",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              <section>
                <Typography>Custom Denomination :</Typography>
                <Typography style={{ color: "red", fontSize: "14px" }}>
                  <strong>Note:</strong> Price range must be between {min ?? "--"}{" "}
                  to {max ?? "--"}
                </Typography>
                <TextField
                  type="text"
                  className="rounded  py-2"
                  id="denominationsCustom"
                  value={denominationsCustomInput}
                  disabled={!isCustomCurrency}
                  onChange={handleDenominationCustomInput}
                  placeholder="Enter custom value"
                />
                <button
                  disabled={
                    !isCustomCurrency ||
                    !denominationsCustomInput ||
                    Number(denominationsCustomInput) <= 0
                  }
                  onClick={AddDenominationCustomInArray}
                >
                  {denominationsCustomInput ? "Add" : "Enter Value"}
                </button>
              </section>

              <section>
                {sortedDenominationsCustom.length > 0 &&
                  sortedDenominationsCustom.map((item, index) => (
                    <Chip
                      key={`${item}-${index}`}
                      onDelete={
                        isCustomCurrency
                          ? () => {
                            const originalIndex =
                              denominationsCustom.indexOf(item);
                            handleDeleteDenominationCustom(originalIndex);
                          }
                          : undefined
                      }
                      label={item}
                    />
                  ))}
              </section>
            </section>

            <section>
              <Typography> how to use points :</Typography>
              <TextField
                type="text"
                className="rounded  py-2"
                id="points"
                value={pointInput}
                onChange={(e) => {
                  setPointInput(e.target.value);
                }}
              />
              <button
                disabled={pointInput ? false : true}
                onClick={AddPointInArray}
              >
                {pointInput ? "Add Point" : "Enter Point"}
              </button>
            </section>
            <section>
              {pointArray &&
                pointArray.length > 0 &&
                pointArray.map((item, index) => {
                  return (
                    <Chip
                      key={index}
                      onDelete={() => {
                        handleDeletePoint(index);
                      }}
                      label={item}
                    />
                  );
                })}
            </section>

            <section style={{ display: "flex" }}>
              <Typography> Detail color :</Typography>

              {detailColorArray.map((color, index) => (
                <TextField
                  key={index}
                  type="color"
                  className="rounded py-2"
                  id={`detail_color${index}`}
                  value={color}
                  onChange={(e) => onChangeHandlerColor(index, e.target.value)}
                  style={{ width: "100px", margin: "10px" }}
                />
              ))}
            </section>

            <section>
              <Typography> Percentage :</Typography>
              <TextField
                type="text"
                className="rounded  py-2"
                id="c_percentage"
                value={coupons?.c_percentage}
                onChange={onChangeHandler}
              />
            </section>

            <section>
              <Typography> partner_link :</Typography>
              <TextField
                type="link"
                className="rounded  py-2"
                id="partner_link"
                value={coupons?.partner_link}
                onChange={onChangeHandler}
              />
            </section>

            <section>
              <Typography>Small Image :</Typography>
              {smallImage ? (
                <button
                  onClick={() => {
                    setSmallImage("");
                  }}
                >
                  Re-Upload
                </button>
              ) : (
                <TextField
                  type="file"
                  id="smallimage"
                  onChange={handlefileInput}
                  placeholder="Select Image"
                  accept="image/*"
                />
              )}
            </section>
            <section>
              {smallImage && <img src={smallImage} width={"50px"} />}
            </section>
          </section>
        </section>
        <button
          style={{
            padding: "15px 25px",
            background: "grey",
            color: "#fff",
            cursor: "pointer",
          }}
          onClick={updateHandler}
        >
          Update
        </button>
      </div>
    </>
  );
}

export default Edit;
